module.exports = __webpack_public_path__ + "static/media/comment-image.51bc4085.svg";